import {gql} from "@apollo/client";

export const AssetIotAlertList = gql`
    query AssetIotAlertList($id: ID!, $filter: IotAlertFilterInput, $pagination: PaginationInput) {
        assetLocation(id: $id) {
            id
            iotAlertList(filter: $filter, pagination: $pagination) {
                total
                alerts {
                    id
                    severity
                    title
                    message
                    detectedAt
                    status
                    allowAcknowledge
                }
            }
        }
    }
`;
